import { useMutation } from '@tanstack/react-query'
import { api } from 'api'
import { toaster } from 'uikit/Toaster'

export const useDeleteBannerItem = () => {
  return useMutation({
    mutationFn: (data) => api.banner.deleteItem(data),
    onSuccess: () => {
      toaster.create({
        title: 'Готово',
        description: 'Баннер успешно удален',
        type: 'success',
      })
    },
    onError: () => {
      toaster.create({
        title: 'Ошибка',
        description: 'Не удалось удалить баннер',
        type: 'error',
      })
    },
  })
}
